<template>
    <div class="service-add-edit">
        <el-form :model="roleForm" :rules="roleFormRules" ref="roleForm" label-width="107px">
            <div class="service-add-edit-module module-item-style">
                <el-form-item label="登录手机号：" prop="csMobile" class="form-item">
                    <el-input v-model="roleForm.csMobile" :disabled="showchangePwd" placeholder="登录手机号"></el-input>
                    <span class="tips">注意：此手机号是唯一标识，添加后请谨慎删除，删除后不能再使用</span>
                </el-form-item>
                <div class="service-pwd-container" v-if="!showchangePwd">
                    <el-form-item label="密码：" prop="csPwd">
                        <el-input type="password" v-model="roleForm.csPwd" placeholder="密码"></el-input>
                    </el-form-item>
                </div>
                <div class="service-pwd-container" v-if="showchangePwd">
                    <el-form-item label="密码：" prop="">
                        <span class="service-change-pwd" @click="pwdPanel">修改密码</span>
                    </el-form-item>
                </div>
                <el-form-item label="确认密码：" prop="confirmpwd" v-if="!showchangePwd">
                    <el-input type="password" v-model="roleForm.confirmpwd" placeholder="确认密码"></el-input>
                </el-form-item>
                <el-form-item label="账号名称：" prop="csName">
                    <el-input type="text" v-model="roleForm.csName" placeholder="账号名称"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名：" prop="csRealname">
                    <el-input v-model="roleForm.csRealname" placeholder="真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="工号：" prop="csNo">
                    <el-input v-model="roleForm.csNo" placeholder="工号"></el-input>
                </el-form-item>
                <el-form-item label="服务上限：" prop="maxServiceNum" class="form-item">
                    <el-input v-model="roleForm.maxServiceNum" placeholder="服务上限"></el-input>
                    <span class="tips">客服人员最多能同时接待的对话数，设为 0 则此客服不会被自动分配到对话</span>
                </el-form-item>
                <!--        <p class="tips-info">客服人员最多能同时接待的对话数，设为 0 则此客服不会被自动分配到对话</p>-->
                <div v-if="showchangePwd">
                    <el-form-item label="帐号权限：" prop="csType"
                                  v-if="currentRoleType != 0 || (currentRoleType == 0 && editRoleType > 0)">
                        <el-radio-group v-model="roleForm.csType">
                            <el-radio v-if="item.roleId != 0" :label="item.roleId" v-for="item in csTypeList"
                                      :key="item.roleId">{{item.roleName}}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="帐号权限：" prop="csType">
                        <el-radio-group v-model="roleForm.csType">
                            <el-radio v-if="item.roleId != 0" :label="item.roleId" v-for="item in csTypeList"
                                      :key="item.roleId">{{item.roleName}}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>

                <span class="wl-btn" @click="submitRole('roleForm')">保存</span>
            </div>
        </el-form>

        <el-dialog
                title="修改密码"
                :visible.sync="dialogVisible"
                width="30%">
            <el-form :model="accountForm" :rules="accountFormRules" ref="accountForm" label-width="100px"
                     class="setting-change-pwd-form">
                <el-form-item
                        label="原密码"
                        prop="oldPwd"
						v-if="!showOldPwd">
                    <el-input type="password" v-model="accountForm.oldPassword" autocomplete="off"
                              placeholder="请输入原密码"></el-input>
                </el-form-item>
                <el-form-item
                        label="新密码"
                        prop="newPwd">
                    <el-input type="password" v-model="accountForm.newPassword" minlength="6" maxlength="32"
                              autocomplete="off" placeholder="请输入6～32位字母或数字"></el-input>
                </el-form-item>
                <el-form-item
                        label="确认新密码"
                        prop="checkPwd">
                    <el-input type="password" v-model="accountForm.confirmPass" minlength="6" maxlength="32"
                              autocomplete="off" placeholder="请确认新密码"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="changePwdConfirm('accountForm')">确 定</el-button>
  </span>
        </el-dialog>

    </div>
</template>

<script>
    import avatar0 from '@/assets/images/client_avatar_empty.png'
    import avatar1 from '@/assets/images/client_avatar1.png'
    import avatar2 from '@/assets/images/client_avatar2.png'
    import avatar3 from '@/assets/images/client_avatar3.png'
    import avatar4 from '@/assets/images/client_avatar4.png'
    import avatar5 from '@/assets/images/client_avatar5.png'
    import avatar6 from '@/assets/images/client_avatar6.png'
    import avatar7 from '@/assets/images/client_avatar7.png'

    export default {
        name: 'service-add-edit',

        data() {
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else if (value.trim().length < 6) {
                    callback(new Error('请输入至少6位新密码'));
                } else if (value.trim().length > 32) {
                    callback(new Error('最多输入32位新密码'));
                } else {
                    callback();
                }
            };
            let validateCheckPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.roleForm.csPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                dialogVisible: false,
                showchangePwd: false,
				showOldPwd:1,
                accountForm: {
                    csMobile:'',
                    oldPassword: '',
                    newPassword: '',
                    confirmPass: ''
                },
                accountFormRules: {
                    oldPassword: [
                        {required: true, message: '请输入原密码', trigger: 'blur'}
                    ],
                    newPassword: [
                        {required: true, validator: validatePass, trigger: 'blur'}
                    ],
                    confirmPass: [
                        {required: true, validator: validateCheckPass, trigger: 'blur'}
                    ],
                },
                roleForm: {
                    csMobile: '',
                    csPwd: '',
                    confirmpwd: '',
                    csName: '',
                    csRealname: '',
                    csNo: '',
                    maxServiceNum: '',
                    csType: 2,
                },
                editRoleType: '',
                csTypeList: [],
                roleFormRules: {
                    csMobile: [
                        {required: true, message: '请输入登录手机号', trigger: 'blur'},
                    ],
                    csPwd: [
                        {required: true, validator: validatePass, trigger: 'blur'},
                    ],
                    confirmpwd: [
                        {required: true, validator: validateCheckPass, trigger: 'blur'},
                    ],
                    csName: [
                        {required: true, message: '账号名称不能为空', trigger: 'blur'},
                    ],
                    maxServiceNum: [
                        {required: true, message: '服务上限不能为空', trigger: 'blur'},
                    ],
                    csType: [
                        {required: true, message: '服务上限不能为空', trigger: 'blur'},
                    ],
                }
            }
        },
        computed: {
            currentRoleType() {
                return this.$store.getters.user.role
            }
        },
        created() {

            this.getRoleType()
            if (this.$route.name == 'serviceEdit') {
                this.getEditData()
                this.showchangePwd = true
            } else {
                this.showchangePwd = false
            }
        },
        mounted() {

        },
        methods: {
            submitRole(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!this.showchangePwd) { // 添加保存
                            this.$http.addChildServiceAPI(this.roleForm).then(res => {
                                if (res.status == 1) {
                                    this.$router.push({
                                        path: '/service-all'
                                    })
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                    })
                                }
                            })
                        } else { // 编辑保存
                            let postEditData = {
                                id: this.roleForm.csId,
                                csName: this.roleForm.csName,
                                csRealname: this.roleForm.csRealname,
                                csNo: this.roleForm.csNo,
                                maxServiceNum: this.roleForm.maxServiceNum,
                                csType: this.roleForm.csType,
                            }
                            this.$http.editChildServiceAPI(postEditData).then(res => {
                                if (res.status == 1) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                    })
                                    this.$router.push({
                                        path: '/service-all'
                                    })
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                    })
                                }
                            })
                        }

                    } else {

                        return false;
                    }
                });
            },
            /**
             * 获取角色类型-
             */
            getRoleType() {
                this.$http.getServiceTypeListAPI().then(res => {
                    if (res.status == 1) {
                        this.csTypeList = res.data.cstypeList
                    }
                }).catch(err => {

                })
            },
            getEditData() {
                this.$http.getChildServiceDataAPI({
                    id: this.$route.query.id
                }).then(res => {
                    if (res.status == 1) {
                        this.roleForm = res.data.csInfo
                        this.editRoleType = res.data.csInfo.csType
						this.showOldPwd = res.data.isSubordinate
                        this.accountForm.csMobile = this.roleForm.csMobile
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            pwdPanel() {
                this.dialogVisible = true
                this.accountForm = {
                    csMobile:this.roleForm.csMobile,
                    oldPassword: '',
                    newPassword: '',
                    confirmPass: ''
                }
            },
            changePwdConfirm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let postData = this.accountForm
                        this.$http.changePasswordAPI(postData).then(res => {
                            if (res.status == 1) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                })
                                this.dialogVisible = false
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    .service-add-edit {
        padding-bottom: 100px;

        .service-add-edit-module {
            margin-bottom: 10px;

            .el-form-item__label {
                color: #333;
                font-weight: bold;
            }

            .form-item {
                .el-form-item__content {
                    display: flex;
                    align-items: center;

                    .el-input {
                        width: auto;
                    }

                    .tips {
                        font-size: 12px;
                        color: #ADADAD;
                        padding-left: 10px;
                        font-weight: bold;
                        line-height: initial;
                    }
                }
            }

            input {
                width: 180px;
            }

            .tips-info {
                font-size: 12px;
                color: #999;
                padding-left: 107px;
                padding-bottom: 10px;
            }

            .service-pwd-container {
                display: flex;

                .service-change-pwd {
                    color: $mainColor;
                    font-size: 12px;
                    cursor: pointer;
                    line-height: 40px;
                    margin-left: 10px;
                }
            }
        }

        .service-operation-container {
            background-color: #fff;
            text-align: center;
            padding: 25px 0;

            span + span {
                margin-left: 15px;
            }
        }
    }
</style>
